export default function (_ref) {
  var store = _ref.store,
      error = _ref.error,
      redirect = _ref.redirect,
      res = _ref.res;

  if (!store.state.authUser) {
    error({
      message: 'Permission denied',
      statcusCode: 401
    });
  }
  //
  var roleID = store.state.authUser.roleID.toLowerCase();
  if (!['user', 'superadmin'].includes(roleID)) {
    error({
      message: 'Permission denied',
      statcusCode: 401
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./middleware/authorizeAdmin.js
// module id = ./middleware/authorizeAdmin.js
// module chunks = 82